module.exports = __webpack_public_path__ + "img/02.d7b85b91.jpg";